<h5 class="title-screen">受付一覧</h5>
<div class="content-box">
    <div class="box-search">
        <div class="row">
            <div class="condition col-9">

            </div>
            <div class="list-button col-3">
                <div class="float-right">
                    <button type="button" class="btn icon-button icon-conditions"
                        (click)="openDetailConditions(DetailConditions)">{{'STR_BTN_CONDITION_SEARCH'|
                        translate}}</button>
                    <button type="button" class="btn icon-button icon-search">{{'STR_BTN_SEARCH'| translate}}</button>
                </div>
            </div>
        </div>
    </div>
    <div class="box-result">
        <div class="table-content-top">
            <label class="custom-checkbox checkboxAll">{{'STR_CHOOSE_ALL_CHECKBOX'| translate}}
                <input type="checkbox" checked="checked">
                <span class="checkmark"></span>
            </label>
            <div class="float-right">
                <div class="icon-img icon-update active"></div>
                <button type="button" class="btn icon-button icon-download">{{'STR_BTN_DOWNLOAD_CSV'|
                    translate}}</button>
            </div>
        </div>
        <div class="tablefixedhead">
            <div class="box-theadtable">
                <table class="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th rowspan="2" class="text-center checkbox-option" scope="col">
                            </th>
                            <th rowspan="2" class="text-center" scope="col">通番</th>
                            <th rowspan="2" class="text-center" scope="col">受診日</th>
                            <th rowspan="2" class="text-center" scope="col">時間</th>
                            <th rowspan="2" class="text-center" scope="col">受診番号</th>
                            <th rowspan="2" class="text-center" scope="col">受付状況</th>
                            <th rowspan="2" class="text-center" scope="col">健診コース</th>
                            <th rowspan="2" rowspan="2" class="text-center" scope="col">氏名</th>
                            <th rowspan="2" class="text-center" scope="col">性別</th>
                            <th rowspan="2" class="text-center" scope="col">年齢</th>
                            <th rowspan="2" class="text-center" scope="col">所属情報</th>
                            <th rowspan="2" class="text-center" scope="col">注意事項1</th>
                            <th rowspan="2" class="text-center" scope="col">注意事項2</th>
                            <th rowspan="1" class="text-center" scope="col">注意事項3</th>
                        </tr>
                        <tr>
                            <th rowspan="1" class="text-center" scope="col">注意事項4</th>
                        </tr>
                    </thead>
                </table>
            </div>
            <div class="box-tbodytable scrollbar">
                <table class="table table-bordered table-striped">
                    <tbody>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr class="active">
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox" checked="checked">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="list-button row">
        <div class="col-12">
            <div class="float-right">
                <button type="button" class="btn btn-f1">
                    <span>F1</span>
                    <span></span>
                </button>
                <button type="button" class="btn btn-f2">
                    <span>F2</span>
                    <span></span>
                </button>
                <button type="button" class="btn btn-f3">
                    <span>F3</span>
                    <span></span>
                </button>
                <button type="button" class="btn btn-f4">
                    <span>F4</span>
                    <span></span>
                </button>
                <button type="button" class="btn btn-f5">
                    <span>F5</span>
                    <span></span>
                </button>
                <button type="button" class="btn btn-f6">
                    <span>F6</span>
                    <span></span>
                </button>
                <button type="button" class="btn btn-f7">
                    <span>F7</span>
                    <span></span>
                </button>
                <button type="button" class="btn btn-f8">
                    <span>F8</span>
                    <span></span>
                </button>
                <button type="button" class="btn btn-f9">
                    <span>F9</span>
                    <span></span>
                </button>
                <button type="button" class="btn btn-f10">
                    <span>F10</span>
                    <span></span>
                </button>
                <button type="button" class="btn btn-f11">
                    <span>F11</span>
                    <span></span>
                </button>
                <button type="button" class="btn btn-f12">
                    <span>F12</span>
                    <span></span>
                </button>
            </div>
        </div>
    </div>
</div>
<h5 class="title-screen">受付入力確認</h5>
<div class="row">
    <div class="col-3">
        <div class="content-box">
            <div class="date-box">
                <bs-datepicker-inline [bsValue]="bsInlineValue" [bsConfig]="{ showWeekNumbers: false }">
                </bs-datepicker-inline>
            </div>
            <div class="title-custom title-custom-icon-reserve">
                <span>保険情報</span>
            </div>
            <div class="table-box table-box-left tablefixedhead table-insurance-information">
                <div class="box-theadtable">
                    <table class="table table-bordered table-striped">
                        <thead>
                            <tr>
                                <th style="width:15%" class="text-center" scope="col">状況</th>
                                <th style="width:30%" class="text-center" scope="col">予約時間</th>
                                <th style="width:55%" class="text-center" scope="col">氏名</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="box-tbodytable scrollbar">
                    <table class="table table-bordered table-striped">
                        <tbody>
                            <tr class="type-1">
                                <td style="width:15%" class="text-center"></td>
                                <td style="width:30%" class="text-center">09:00</td>
                                <td style="width:55%">保険情報</td>
                            </tr>
                            <tr class="type-1">
                                <td class="text-center"></td>
                                <td class="text-center">09:00</td>
                                <td>保険情報</td>
                            </tr>
                            <tr class="type-1">
                                <td class="text-center"></td>
                                <td class="text-center">09:00</td>
                                <td>保険情報</td>
                            </tr>
                            <tr class="type-1">
                                <td class="text-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                                        class="bi bi-check" viewBox="0 0 16 16">
                                        <path
                                            d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
                                    </svg>
                                </td>
                                <td class="text-center">09:00</td>
                                <td>保険情報</td>
                            </tr>
                            <tr class="type-1 active">
                                <td class="text-center"></td>
                                <td class="text-center">09:00</td>
                                <td>保険情報</td>
                            </tr>
                            <tr>
                                <td class="text-center"></td>
                                <td class="text-center">11:00</td>
                                <td>保険情報</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <span class="bi-circle">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                            class="bi bi-circle" viewBox="0 0 16 16">
                                            <path
                                                d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                        </svg>
                                    </span>
                                </td>
                                <td class="text-center">13:00</td>
                                <td>保険情報</td>
                            </tr>
                            <tr>
                                <td class="text-center"></td>
                                <td class="text-center">13:00</td>
                                <td>保険情報</td>
                            </tr>
                            <tr>
                                <td class="text-center"></td>
                                <td class="text-center">13:00</td>
                                <td>保険情報</td>
                            </tr>
                            <tr>
                                <td class="text-center"></td>
                                <td class="text-center">13:00</td>
                                <td>保険情報</td>
                            </tr>
                            <tr>
                                <td class="text-center"></td>
                                <td class="text-center">13:00</td>
                                <td>保険情報</td>
                            </tr>
                            <tr>
                                <td class="text-center"></td>
                                <td class="text-center">13:00</td>
                                <td>保険情報</td>
                            </tr>
                            <tr>
                                <td class="text-center"></td>
                                <td class="text-center">13:00</td>
                                <td>保険情報</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="col-9">
        <div class="content-box">
            <div class="accepted-box box-search">
                <div class="row">
                    <div class="col-7">
                        <div class="form-inline">
                            <button type="button" class="btn btn-accepted">仮予約</button>
                            <div class="consulting-date form-inline">
                                <label>予約日</label>
                                <div class="form-calendar">
                                    <input type="text" class="form-control-calendar form-control" bsDatepicker
                                        #datepicker="bsDatepicker">
                                    <span class="date-icon" (click)="datepicker.toggle()"></span>
                                </div>
                            </div>
                            <div class="consulting-number form-inline">
                                <label>受診番号</label>
                                <input type="text" class="form-control">
                            </div>
                            <button type="button" class="btn icon-button icon-search" (click)="openPopReservationDate()">{{'STR_RSV_DATETIME' | translate}}</button>
                            <div class="icon-img icon_smartphone active"></div>
                        </div>
                    </div>
                    <div class="col-5">
                        <div class="float-right">
                            <div class="icon-img icon-note active"></div>
                            <div class="icon-img icon-note active"></div>
                            <div class="icon-img icon-note"></div>
                            <div class="icon-img icon-attention active"></div>
                            <div class="icon-img icon-remarks active"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="information-box box-result" style="min-height: 200px;">
                <div class="row box-input">
                    <div class="col-7 float-left">
                        <div class="title-custom title-custom-type-1">
                            <span>受診者情報</span>
                        </div>
                        <div class="row-input">
                        </div>
                        <div class="row-input">
                        </div>
                        <div class="row-input">
                        </div>
                        <div class="row-input">
                        </div>
                        <div class="row-input">
                        </div>
                        <div class="row-input">
                        </div>
                    </div>
                    <div class="col-5 float-right">
                        <div class="title-custom title-custom-type-1">
                            <span>保険情報</span>
                        </div>
                        <div class="insurance-information">
                            <div class="row-input">
                            </div>
                            <div class="row-input">
                            </div>
                            <div class="row-input">
                            </div>
                        </div>
                        <div class="title-custom title-custom-type-1">
                            <span>備考</span>
                        </div>
                        <textarea class="form-control input-remarks" rows="3" style="resize:none;"></textarea>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4 float-left">
                        <div class="title-custom title-custom-type-2">
                            <span>コース情報</span>
                        </div>
                        <div class="table-border-radius table-course-information">
                            <div class="tablefixedhead">
                                <div class="box-theadtable">
                                    <table class="table table-bordered table-striped">
                                        <thead>
                                            <tr>
                                                <th style="width:70%" class="text-center" scope="col">検査項目</th>
                                                <th style="width:30%" class="text-center" scope="col">本人負担額</th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div class="box-tbodytable scrollbar">
                                    <table class="table table-bordered table-striped">
                                        <tbody>
                                            <tr>
                                                <td style="width:70%">
                                                    <label class="custom-radio">受診者情報
                                                        <input type="radio" name="radio" id="1" checked>
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </td>
                                                <td style="width:30%" class="text-right">5,500</td>
                                            </tr>
                                            <tr class="active">
                                                <td style="width:70%">
                                                    <label class="custom-radio">受診者情報
                                                        <input type="radio" name="radio" id="1" checked>
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </td>
                                                <td style="width:30%" class="text-right">11,000</td>
                                            </tr>
                                            <tr>
                                                <td style="width:70%"></td>
                                                <td style="width:30%"></td>
                                            </tr>
                                            <tr>
                                                <td style="width:70%"></td>
                                                <td style="width:30%"></td>
                                            </tr>
                                            <tr>
                                                <td style="width:70%"></td>
                                                <td style="width:30%"></td>
                                            </tr>
                                            <tr>
                                                <td style="width:70%"></td>
                                                <td style="width:30%"></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4 float-right">
                        <div class="title-custom title-custom-type-2">
                            <span>オプション情報</span>
                        </div>
                        <div class="table-border-radius table-option-information">
                            <div class="tablefixedhead">
                                <div class="box-theadtable">
                                    <table class="table table-bordered table-striped">
                                        <thead>
                                            <tr>
                                                <th style="width:70%" class="text-center" scope="col">オプション名</th>
                                                <th style="width:30%" class="text-center" scope="col">本人負担額</th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div class="box-tbodytable scrollbar">
                                    <table class="table table-bordered table-striped">
                                        <tbody>
                                            <tr>
                                                <td style="width:70%">
                                                    <label class="custom-checkbox">保険情報
                                                        <input type="checkbox">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </td>
                                                <td style="width:30%" class="text-right">33,000</td>
                                            </tr>
                                            <tr class="active">
                                                <td style="width:70%">
                                                    <label class="custom-checkbox">保険情報
                                                        <input type="checkbox" checked="checked">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </td>
                                                <td style="width:30%" class="text-right">11,000</td>
                                            </tr>
                                            <tr>
                                                <td style="width:70%">
                                                    <label class="custom-checkbox">保険情報
                                                        <input type="checkbox">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </td>
                                                <td style="width:30%" class="text-right">33,000</td>
                                            </tr>
                                            <tr>
                                                <td style="width:70%">
                                                    <label class="custom-checkbox">保険情報
                                                        <input type="checkbox">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </td>
                                                <td style="width:30%" class="text-right">33,000</td>
                                            </tr>
                                            <tr>
                                                <td style="width:70%">
                                                </td>
                                                <td style="width:30%" class="text-right"></td>
                                            </tr>
                                            <tr>
                                                <td style="width:70%">
                                                </td>
                                                <td style="width:30%" class="text-right"></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4 float-right">
                        <div class="title-custom title-custom-type-2">
                            <span>受診項目</span>
                        </div>
                        <div class="examined-box">
                            <div class="form-row">
                                <div class="col active">
                                    <label class="custom-checkbox">選択1
                                        <input type="checkbox" checked="checked">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="col active">
                                    <label class="custom-checkbox">選択2
                                        <input type="checkbox" checked="checked">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="col active">
                                    <label class="custom-checkbox">選択3
                                        <input type="checkbox" checked="checked">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col">
                                    <label class="custom-checkbox">選択4
                                        <input type="checkbox">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="col active">
                                    <label class="custom-checkbox">選択5
                                        <input type="checkbox" checked="checked">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="col active">
                                    <label class="custom-checkbox">選択6
                                        <input type="checkbox" checked="checked">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col">
                                    <label class="custom-checkbox">選択7
                                        <input type="checkbox">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="col">
                                    <label class="custom-checkbox">選択8
                                        <input type="checkbox">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="col">
                                    <label class="custom-checkbox">選択9
                                        <input type="checkbox">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col">
                                    <label class="custom-checkbox">選択10
                                        <input type="checkbox">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="col">
                                    <label class="custom-checkbox">選択11
                                        <input type="checkbox">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="col">
                                    <label class="custom-checkbox">選択12
                                        <input type="checkbox">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="float-left box-amount">
                            <div class="title-custom title-custom-type-3">
                                <span>合計金額（本人負担額）</span>
                            </div>
                            <div class="total-amount text-right">
                                <span class="money-character">￥</span>
                                <span class="money-text">22,000</span>
                                <span class="tax-text">(税込)</span>
                            </div>
                        </div>
                        <div class="float-right box-button-status">
                            <button class="btn icon-button button-status-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                                </svg>
                                問診入力済</button>
                            <button class="btn icon-button button-status-2">
                                <span class="shadow-mark-svg"></span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                                </svg>
                                送付物済</button>
                            <button class="btn icon-button button-status-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                                </svg>
                                送付物済</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="list-button row">
                <div class="col-12">
                    <div class="float-right">
                        <button type="button" class="btn btn-f1">
                            <span>F1</span>
                            <span></span>
                        </button>
                        <button type="button" class="btn btn-f2">
                            <span>F2</span>
                            <span></span>
                        </button>
                        <button type="button" class="btn btn-f3">
                            <span>F3</span>
                            <span></span>
                        </button>
                        <button type="button" class="btn btn-f4" (click)="openPopQuestionareAnsInp()">
                            <span>F4</span>
                            <span></span>
                        </button>
                        <button type="button" class="btn btn-f5">
                            <span>F5</span>
                            <span></span>
                        </button>
                        <button type="button" class="btn btn-f6">
                            <span>F6</span>
                            <span></span>
                        </button>
                        <button type="button" class="btn btn-f7">
                            <span>F7</span>
                            <span></span>
                        </button>
                        <button type="button" class="btn btn-f8">
                            <span>F8</span>
                            <span></span>
                        </button>
                        <button type="button" class="btn btn-f9">
                            <span>F9</span>
                            <span></span>
                        </button>
                        <button type="button" class="btn btn-f10">
                            <span>F10</span>
                            <span></span>
                        </button>
                        <button type="button" class="btn btn-f11">
                            <span>F11</span>
                            <span></span>
                        </button>
                        <button type="button" class="btn btn-f12">
                            <span>F12</span>
                            <span></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #DetailConditions>
    <div class="modal-header">
        <h4 class="modal-title pull-left">保険情報</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="title-custom title-custom-type-1">
            <span>保険情報</span>
        </div>
        <div class="box-input">
            <div class="row-input">
            </div>
            <div class="row-input">
            </div>
            <div class="row-input">
            </div>
            <div class="row-input">
            </div>
            <div class="row-input">
            </div>
            <div class="row-input">
            </div>
        </div>
        <div class="float-right">
            <button type="button" class="btn btn-f11">OK</button>
        </div>
    </div>
</ng-template>
<button class="btn btn-secondary" (click)="openModalW1840(ModalW1840)" style="margin-right: 8px;">1840*820</button>
<button class="btn btn-secondary" (click)="openModalW1240(ModalW1240)" style="margin-right: 8px;">1240*820</button>
<button class="btn btn-secondary" (click)="openModalW640(ModalW640)" style="margin-right: 8px;">640*820</button>
<button class="btn btn-secondary" (click)="openModalW640v2(ModalW640v2)" style="margin-right: 8px;">640*480</button>
<button class="btn btn-success" (click)="openModalSuccess()" style="margin-right: 8px;">Modal Success</button>
<button class="btn btn-danger" (click)="openModalError()" style="margin-right: 8px;">Modal Error</button>
<button class="btn btn-info" (click)="openModalInfo()" style="margin-right: 8px;">Modal Info</button>
<button class="btn btn-info" (click)="openModalConfirm()" style="margin-right: 8px;">Modal Confirm</button>
<button class="btn btn-info" (click)="openModalFAC0008(ModalFAC0008)" style="margin-right: 8px;">Modal FAC0008</button>
<button class="btn btn-info" (click)="openModalFAC0009(ModalFAC0009)" style="margin-right: 8px;">Modal FAC0009</button>
<button class="btn btn-info" (click)="openModalFAC0006(ModalFAC0006)" style="margin-right: 8px;">Modal FAC0006</button>
<button class="btn btn-info" (click)="openModalFAC0205(ModalFAC0205)" style="margin-right: 8px;">Modal FAC0205</button>
<button class="btn btn-secondary" (click)="openModalFAC0404(ModalFAC0404)" style="margin-right: 8px;">FAC-0404</button>
<button class="btn btn-secondary" (click)="openModalFAC0905(ModalFAC0905)" style="margin-right: 8px;">FAC-0905</button>
<ng-template #ModalW1840>
    <div class="modal-header">
        <h4 class="modal-title pull-left">タイトル</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalW1840.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body h820">
        <div class="title-custom title-custom-type-1">
            <span>タイトル</span>
        </div>
        <div class="box-input">
            <div class="row-input">
            </div>
            <div class="row-input">
            </div>
        </div>
        <div class="title-custom title-custom-type-1">
            <span>タイトル</span>
        </div>
        <div class="form-row box-sector">
            <div class="col active"></div>
            <div class="col"></div>
            <div class="col"></div>
        </div>
        <div class="table-responsive">
            <div class="tablefixedhead">
                <div class="box-theadtable">
                    <table class="table table-bordered table-striped">
                        <thead>
                            <tr>
                                <th class="text-center" scope="col">
                                </th>
                                <th class="text-center" scope="col"></th>
                                <th class="text-center" scope="col"></th>
                                <th class="text-center" scope="col"></th>
                                <th class="text-center" scope="col"></th>
                                <th class="text-center" scope="col"></th>
                                <th class="text-center" scope="col"></th>
                                <th class="text-center" scope="col"></th>
                                <th class="text-center" scope="col"></th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="box-tbodytable scrollbar">
                    <table class="table table-bordered table-striped">
                        <tbody>
                            <tr>
                                <th class="text-center" scope="row">
                                </th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="text-center" scope="row">
                                </th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="text-center" scope="row">
                                </th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="text-center" scope="row">
                                </th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="text-center" scope="row">
                                </th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="text-center" scope="row">
                                </th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="text-center" scope="row">
                                </th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="text-center" scope="row">
                                </th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="text-center" scope="row">
                                </th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="text-center" scope="row">
                                </th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="text-center" scope="row">
                                </th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="text-center" scope="row">
                                </th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="text-center" scope="row">
                                </th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="text-center" scope="row">
                                </th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="list-button float-right">
            <button type="button" class="btn btn-f1">
                <span>F1</span>
                <span></span>
            </button>
            <button type="button" class="btn btn-f2">
                <span>F2</span>
                <span></span>
            </button>
            <button type="button" class="btn btn-f3">
                <span>F3</span>
                <span></span>
            </button>
            <button type="button" class="btn btn-f4">
                <span>F4</span>
                <span></span>
            </button>
            <button type="button" class="btn btn-f5">
                <span>F5</span>
                <span></span>
            </button>
            <button type="button" class="btn btn-f6">
                <span>F6</span>
                <span></span>
            </button>
            <button type="button" class="btn btn-f7">
                <span>F7</span>
                <span></span>
            </button>
            <button type="button" class="btn btn-f8">
                <span>F8</span>
                <span></span>
            </button>
            <button type="button" class="btn btn-f9">
                <span>F9</span>
                <span></span>
            </button>
            <button type="button" class="btn btn-f10">
                <span>F10</span>
                <span></span>
            </button>
            <button type="button" class="btn btn-f11">
                <span>F11</span>
                <span></span>
            </button>
            <button type="button" class="btn btn-f12">
                <span>F12</span>
                <span></span>
            </button>
        </div>
    </div>
</ng-template>
<ng-template #ModalW1240>
    <div class="modal-header">
        <h4 class="modal-title pull-left">タイトル </h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalW1240.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body h820">
        <div class="title-custom title-custom-type-1">
            <span>タイトル</span>
        </div>
        <div class="box-input">
            <div class="row-input">
            </div>
            <div class="row-input">
            </div>
        </div>
        <div class="title-custom title-custom-type-1">
            <span>タイトル</span>
        </div>
        <div class="form-row box-sector">
            <div class="col active"></div>
            <div class="col"></div>
            <div class="col"></div>
        </div>
        <div class="table-responsive">
            <div class="tablefixedhead">
                <div class="box-theadtable">
                    <table class="table table-bordered table-striped">
                        <thead>
                            <tr>
                                <th class="text-center" scope="col">
                                </th>
                                <th class="text-center" scope="col"></th>
                                <th class="text-center" scope="col"></th>
                                <th class="text-center" scope="col"></th>
                                <th class="text-center" scope="col"></th>
                                <th class="text-center" scope="col"></th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="box-tbodytable scrollbar">
                    <table class="table table-bordered table-striped">
                        <tbody>
                            <tr>
                                <th class="text-center" scope="row">
                                </th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="text-center" scope="row">
                                </th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="text-center" scope="row">
                                </th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="text-center" scope="row">
                                </th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="text-center" scope="row">
                                </th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="text-center" scope="row">
                                </th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="text-center" scope="row">
                                </th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="text-center" scope="row">
                                </th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="text-center" scope="row">
                                </th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="text-center" scope="row">
                                </th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="text-center" scope="row">
                                </th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="text-center" scope="row">
                                </th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="text-center" scope="row">
                                </th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="list-button float-right">
            <button type="button" class="btn btn-f9">
                <span>F9</span>
                <span></span>
            </button>
            <button type="button" class="btn btn-f10">
                <span>F10</span>
                <span></span>
            </button>
            <button type="button" class="btn btn-f11">
                <span>F11</span>
                <span></span>
            </button>
            <button type="button" class="btn btn-f12">
                <span>F12</span>
                <span></span>
            </button>
        </div>
    </div>
</ng-template>
<ng-template #ModalW640>
    <div class="modal-header">
        <h4 class="modal-title pull-left">タイトル</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalW1240.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body h820">
        <div class="title-custom title-custom-type-1">
            <span>タイトル</span>
        </div>
        <div class="table-top">
            <div class="tablefixedhead">
                <div class="box-theadtable">
                    <table class="table table-bordered table-striped">
                        <thead>
                            <tr>
                                <th class="text-center" scope="col"></th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="box-tbodytable scrollbar">
                    <table class="table table-bordered table-striped">
                        <tbody>
                            <tr>
                                <td>
                                    <label class="custom-checkbox">
                                        <input type="checkbox">
                                        <span class="checkmark"></span>
                                    </label>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label class="custom-checkbox">
                                        <input type="checkbox" checked="checked">
                                        <span class="checkmark"></span>
                                    </label>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label class="custom-checkbox">
                                        <input type="checkbox">
                                        <span class="checkmark"></span>
                                    </label>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="title-custom title-custom-type-1">
            <span>タイトル</span>
        </div>
        <div class="box-input">
            <div class="row-input row-input-auto-height">
                <textarea class="form-control" rows="16" style="resize:none;"></textarea>
            </div>
        </div>
        <div class="list-button float-right">
            <button type="button" class="btn btn-f9">
                <span>F9</span>
                <span></span>
            </button>
            <button type="button" class="btn btn-f10">
                <span>F10</span>
                <span></span>
            </button>
            <button type="button" class="btn btn-f11">
                <span>F11</span>
                <span></span>
            </button>
            <button type="button" class="btn btn-f12">
                <span>F12</span>
                <span></span>
            </button>
        </div>
    </div>
</ng-template>
<ng-template #ModalW640v2>
    <div class="modal-header">
        <h4 class="modal-title pull-left">タイトル</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalW1240.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body h480">
        <div class="title-custom title-custom-type-1">
            <span>タイトル</span>
        </div>
        <div class="table-top">
            <div class="tablefixedhead">
                <div class="box-theadtable">
                    <table class="table table-bordered table-striped">
                        <thead>
                            <tr>
                                <th class="text-center" scope="col"></th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="box-tbodytable scrollbar">
                    <table class="table table-bordered table-striped">
                        <tbody>
                            <tr>
                                <td>
                                    <label class="custom-checkbox">
                                        <input type="checkbox">
                                        <span class="checkmark"></span>
                                    </label>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label class="custom-checkbox">
                                        <input type="checkbox" checked="checked">
                                        <span class="checkmark"></span>
                                    </label>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label class="custom-checkbox">
                                        <input type="checkbox">
                                        <span class="checkmark"></span>
                                    </label>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="title-custom title-custom-type-1">
            <span>タイトル</span>
        </div>
    </div>
</ng-template>
<ng-template #PopReservationDate>
    <app-pop-reservation-date [valueInput]="valueInput" (sendToParent)="ValueDateSelected($event)"></app-pop-reservation-date>
</ng-template>

<ng-template #ModalFAC0008 >
    <app-pop-examinee-srch (closeModal)="onClose()"></app-pop-examinee-srch>
</ng-template>
<ng-template #ModalFAC0009 >
    <app-pop-enterprise-srch (closeModal)="onClose($event)"></app-pop-enterprise-srch>
</ng-template>
<ng-template #ModalFAC0006>
    <app-modal-mess (closeModal)="onClose()"></app-modal-mess>
</ng-template>

<ng-template #ModalFAC0205 >
    <app-pop-exam-frame-set (eventClosePop)="ClosePop0205($event)"></app-pop-exam-frame-set>
</ng-template>

<ng-template #PopQuestionareAnsInp>
    <app-pop-questionare-ans-inp [valueParent]="valueFAC0012" (sendToParent)="ResultPopQuestionareAnsInp($event)"></app-pop-questionare-ans-inp>
</ng-template>

<ng-template #ModalFacilityReport>
    <app-scr-report-inf></app-scr-report-inf>
</ng-template>
<!-- <ng-template #ModalFAC0010 >
    <app-pop-exam-history (closeModal)="onClose()"></app-pop-exam-history>
</ng-template> -->
<ng-template #ModalFAC0404>
    <div class="modal-header">
        <h4 class="modal-title pull-left">検査結果取り込み</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalW1240.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body h480">
        <div class="title-custom title-custom-type-1">
            <span>ファイル選択</span>
        </div>
        <div class="box-input mb-3">
            <div class="row-input p-1">
                <div class="inp-file-custom">
                    <input type="file" name="" id="inpfile" class="inp-file">
                    <input type="text" class="form-control inp-file-name" placeholder="ファイルを選択したください。" readonly>
                    <label class="btn-inp-file" for="inpfile">選択</label>
                </div>
            </div>
        </div>
        <div class="lst-disc" style="height: 300px;">
            <ul>
                <li>
                    <div class="item-disc">
                        <div class="left">件数</div>
                        <div class="right">34件</div>
                    </div>
                </li>
                <li>
                    <div class="item-disc">
                        <div class="left">受診日</div>
                        <div class="right">2021/05/01~2021/05/04</div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="list-button float-right">
            <button type="button" class="btn btn-f11">
                <span>F12</span>
                <span>取り込み</span>
            </button>
        </div>
    </div>
</ng-template>
<ng-template #ModalFAC0905>
    <div class="modal-header">
        <h4 class="modal-title pull-left">請求確認出力</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalW1240.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body h820">
        <div class="title-custom title-custom-type-1">
            <span>出力対象</span>
        </div>
        <div class="box-input">
            <div class="row-input mb-1">
                <div class="row-common">
                    <div class="text-box-common">
                        <div class="form-group mb-0 mt-1">
                            <label class="w110">請求年月</label>
                            <div class="form-calendar mr-10">
                                <input type="text" maxlength="" class="form-control-calendar form-control w220">
                                <span class="date-icon"></span>
                            </div>
                            <span style="width: 30px;">~</span>
                            <div class="form-calendar mr-10">
                                <input type="text" maxlength="" class="form-control-calendar form-control w220">
                                <span class="date-icon"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row-input row-input-auto-height p-0">
                <div class="row-common">
                    <div class="text-box-common">
                        <div class="form-group mb-2 mt-1">
                            <label class="w110">企業団体</label>
                            <input type="text" class="form-control w220 mr-10">
                            <button class="btn-search-green mr-2">
                                <img src="../../../../../assets/img/icon_search.png" alt="">
                            </button>
                            <input type="text" class="form-control w220" readonly>
                        </div>
                    </div>
                </div>
                <div class="row-common">
                    <div class="text-box-common">
                        <div class="form-group mb-2 mt-1">
                            <label class="w110">請求書番号</label>
                            <input type="text" class="form-control w290 mr-4">
                            <button class="btn icon-button icon-conditions ml-2 mr-0">請求書出力区分</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="box-result">
            <div class="table-content-top">
                <span class="record-num pl-3">1/24件</span>
                <div class="float-right">
                    <button type="button" class="btn icon-button icon-download">一覧ダウンロード</button>
                </div>
            </div>
            <div class="table-common scrollbar" style="height: 460px;">
                <table class="table table-bordered table-striped">
                    <caption style="display: none;"></caption>
                    <thead>
                        <tr>
                            <th class="text-center  w50 checkbox-option" scope="col"></th>
                            <th class="text-center w200" scope="col">請求対象年月</th>
                            <th class="text-center w200" scope="col">請求書番号</th>
                            <th class="text-center w200" scope="col">請求日</th>
                            <th class="text-center w200" scope="col">企業団体コード</th>
                            <th class="text-center w200" scope="col">請求先名称</th>
                            <th class="text-center w200" scope="col">人数</th>
                            <th class="text-center w200" scope="col">請求金額</th>
                            <th class="text-center w200" scope="col">請求書出力区分</th>
                            <th class="text-center w200" scope="col">発行日</th>
                            <th class="text-center w200" scope="col">備考</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="text-center checkbox-option">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>    
                </table>
            </div>
        </div>
        <div class="list-button float-right">
            <button type="button" class="btn btn-f11">
                <span>F12</span>
                <span>取り込み</span>
            </button>
        </div>
    </div>
</ng-template>